import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { VStack } from "@whoosh/design-system/src/components/primitive";
import { RestrictionInfoBarStack } from "@whoosh/features/src/Restrictions/components/RestrictionInfoBarStack/RestrictionInfoBarStack";

import { getRoundRestrictionsByRoundIdAtom } from "../../../../../atoms/selectors/getRoundRestrictionsByRoundIdAtom/getRoundRestrictionsByRoundIdAtom";
import { EditableRound_Booking$key } from "./__generated__/EditableRound_Booking.graphql";
import { GuestRoundHostRate } from "./components/GuestRoundHostRate/GuestRoundHostRate";
import { RoundControls } from "./components/RoundControls/RoundControls";
import { RoundInfoBanners } from "./components/RoundInfoBanners/RoundInfoBanners";
import { RoundPlayerLine } from "./components/RoundPlayerLine/RoundPlayerLine";

type Props = {
  roundId: string;
  bookingRef: EditableRound_Booking$key;
  currentMembershipTypeId: string;
};

export const EditableRound = ({
  roundId,
  bookingRef,
  currentMembershipTypeId,
}: Props) => {
  const booking = useFragment(EditableRoundFragmentString, bookingRef);
  const roundRestrictions = useAtomValue(
    getRoundRestrictionsByRoundIdAtom(roundId)
  );
  return (
    <VStack
      padding={5}
      backgroundColor="surface-primary"
      gap={3}
      testID="editable-round"
    >
      <RoundPlayerLine roundId={roundId} />
      <RoundControls
        roundId={roundId}
        bookingRef={booking}
        currentMembershipTypeId={currentMembershipTypeId}
      />
      <GuestRoundHostRate roundId={roundId} />
      <RoundInfoBanners roundId={roundId} />
      <RestrictionInfoBarStack
        restrictions={roundRestrictions ?? []}
        restrictionContext="Patron"
      />
    </VStack>
  );
};
const EditableRoundFragmentString = graphql`
  fragment EditableRound_Booking on Booking {
    ...RoundControls_Booking
  }
`;
